import $ from 'jquery';
import WorkPage from './WorkPage';
import WorkPageNav, { WORK_TYPES } from './WorkPageNav';
import WorkHistoryManager from './WorkHistoryManager';
import WorkItemButtonManager from './WorkItemButtonManager';
import RepairCategoryUI from './RepairCategoryUI';
import MobileBasketManager from './MobileBasketManager';
import handleMentionMeLink from '../../common/mention_me.coffee';
import EventBus from '../../common/EventBus';

export const SELECTORS = {
  promoTrigger: '.js-show-discount-code',
  promoPanel: '.v2-promo-panel',
  promoForm: '.v2-promotion-code-form',
  searchResults: '#v2-search-results',
  navBtn: '.js-work-type-nav-btn',
  workPageContent: '.work-page-content',
  quoteContainer: '#get-quote',
  mentionMeLink: '.js-mm-link',
  answerBtn: '.js-answer',
  workSearchIcon: '.js-work-search-icon',
  searchInput: '#search-input',
  diagnosticTool: '.js-open-diagnostic-tool',
};

export default class WorkPageController {
  constructor() {
    this.workPage = new WorkPage();
    this.workPageNav = new WorkPageNav(this.workPage);
    this.historyManager = new WorkHistoryManager(this.workPage, this.workPageNav);
    this.buttonManager = new WorkItemButtonManager(this.workPage);
    this.categoryUI = new RepairCategoryUI();
    this.mobileBasketManager = new MobileBasketManager();
    this.workPageContent = $(SELECTORS.workPageContent);
  }

  init() {
    this.buttonManager.init();
    this.historyManager.init();
    this.categoryUI.init();
    this.mobileBasketManager.init();
    this._bindPromoEvents();
    this._bindSearchEvents();
    this._subscribeToSearchEvents();
    this._bindMentionMeLink();
    this._bindAnswerClick();
    this._bindSearchIconClick();
    this._bindDiagnosticToolClick();
  }

  _bindPromoEvents() {
    $(SELECTORS.promoTrigger).on('click', () => {
      $(SELECTORS.promoPanel).toggleClass('hidden');
    });

    $(SELECTORS.promoForm).on('success', () => {
      $(SELECTORS.promoPanel).addClass('hidden');
    });
  }

  _bindSearchEvents() {
    $(SELECTORS.searchResults)
      .on('begin-search-state', () => {
        $(SELECTORS.navBtn).removeClass('active');
      })
      .on('end-search-state', () => {
        $(`${SELECTORS.navBtn}[data-work-type="${this.workPageNav.workType}"]`).addClass('active');
      });
  }

  _subscribeToSearchEvents() {
    EventBus.on('search:started', () => {
      $(SELECTORS.navBtn).removeClass('active');
    });
    EventBus.on('search:ended', () => {
      $(`${SELECTORS.navBtn}[data-work-type="${this.workPageNav.workType}"]`).addClass('active');
    });
  }

  _bindMentionMeLink() {
    $(SELECTORS.quoteContainer).find(SELECTORS.mentionMeLink).on('click', handleMentionMeLink);
  }

  _bindAnswerClick() {
    this.workPageContent.on('click', SELECTORS.answerBtn, function (e) {
      var $this, state, target_panel;
      state = History.getState().data;
      $this = $(this);
      target_panel = $($this.data('target'));
      if (!state.inspection_panel_stack) {
        state.inspection_panel_stack = [$this.attr('id')];
      }
      state.inspection_panel_stack.push(target_panel.data('inspection-panel-id'));
      return History.pushState(
        state,
        '',
        '?type=unknown-problem&a=' +
          $this
            .text()
            .trim()
            .replace(/[^-\w\s]/g, '')
            .replace(/[-\s]+/g, '-')
            .toLowerCase(),
      );
    });
  }

  _bindSearchIconClick() {
    $(SELECTORS.workSearchIcon).on('click', function () {
      const state = History.getState().data;
      if (state.work_type !== WORK_TYPES.repair) {
        state.work_type = WORK_TYPES.repair;
        History.pushState(state, '', `?type=${WORK_TYPES.repair}`);
      }
      $(SELECTORS.searchInput).focus();
    });
  }

  _bindDiagnosticToolClick() {
    $(SELECTORS.diagnosticTool).on('click', function (e) {
      e.preventDefault();

      var workType = WORK_TYPES.unknownProblem;

      History.pushState({ work_type: workType }, '', `?type=${workType}`);
    });
  }
}
